<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01"><a id="page04"> </a><a id="page05">
<div class="chapterBody">
<p class="centerImage1"><img alt="" src="page05.jpg"/></p>
<p class="chapterOpenerText">After the 1993 World Trade Center attack, a division of the Central Intelligence Agency established a domestic unit tasked with protecting America from the threat of terrorism. Headquartered in Washington, D.C., the Counter Terrorist Unit established field offices in several American cities. From its inception, CTU faced hostility and skepticism from other Federal law enforcement agencies. Despite bureaucratic resistance, within a few years CTU had become a major force in the war against terror. After the events of 9/11, a number of early CTU missions were declassified. The following is one of them.</p>
</div>
</a></div><a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061734106_frontmatterpage.vue?e5c03086